var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { assertMonth } from '../../shared/date-types';
import { getMonthNames } from '../../shared/display';
import { SdsDatePickerItem, } from '../../shared/sds-datepicker-item/sds-datepicker-item.lit';
import '../../shared/sds-datepicker-item/sds-datepicker-item.lit';
import { monthDateToKey } from '../month-picker-calculations';
import styles from './month-page-view.lit.scss';
import { sdsCustomElement } from '../../../utilities/custom-components';
/**
 * Control represents a page view for the month-picker
 */
let SdsMonthPageView = (() => {
    var _SdsMonthPageView_pageYear_accessor_storage, _SdsMonthPageView_locale_accessor_storage, _SdsMonthPageView_currentMonth_accessor_storage, _SdsMonthPageView_stateMapper_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-month-page-view')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _pageYear_decorators;
    let _pageYear_initializers = [];
    let _pageYear_extraInitializers = [];
    let _locale_decorators;
    let _locale_initializers = [];
    let _locale_extraInitializers = [];
    let _currentMonth_decorators;
    let _currentMonth_initializers = [];
    let _currentMonth_extraInitializers = [];
    let _stateMapper_decorators;
    let _stateMapper_initializers = [];
    let _stateMapper_extraInitializers = [];
    var SdsMonthPageView = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsMonthPageView_pageYear_accessor_storage.set(this, __runInitializers(this, _pageYear_initializers, new Date().getFullYear()));
            _SdsMonthPageView_locale_accessor_storage.set(this, (__runInitializers(this, _pageYear_extraInitializers), __runInitializers(this, _locale_initializers, 'en')));
            _SdsMonthPageView_currentMonth_accessor_storage.set(this, (__runInitializers(this, _locale_extraInitializers), __runInitializers(this, _currentMonth_initializers, void 0)));
            _SdsMonthPageView_stateMapper_accessor_storage.set(this, (__runInitializers(this, _currentMonth_extraInitializers), __runInitializers(this, _stateMapper_initializers, () => 'none')));
            this._contentContainer = __runInitializers(this, _stateMapper_extraInitializers);
            this._items = [];
            this.itemClickHandler = (event) => {
                if (event.target instanceof SdsDatePickerItem) {
                    this.dispatchEvent(new CustomEvent(SdsMonthPageView.SELECT_EVENT, {
                        detail: {
                            month: assertMonth(parseInt(event.target.identifier)),
                        },
                    }));
                }
            };
            this.itemKeyPressHandler = (event) => {
                if (event.key === 'Enter' && event.target instanceof SdsDatePickerItem) {
                    this.dispatchEvent(new CustomEvent(SdsMonthPageView.SELECT_EVENT, {
                        detail: {
                            month: assertMonth(parseInt(event.target.identifier)),
                        },
                    }));
                }
            };
            this.handleHover = (event) => {
                let hoveredMonth;
                if (event.target instanceof SdsDatePickerItem) {
                    hoveredMonth = isNaN(parseInt(event.target.identifier))
                        ? undefined
                        : parseInt(event.target.identifier);
                }
                this.dispatchEvent(new CustomEvent(SdsMonthPageView.HOVER_EVENT, {
                    detail: {
                        month: hoveredMonth ? assertMonth(hoveredMonth) : undefined,
                    },
                }));
            };
        }
        get pageYear() { return __classPrivateFieldGet(this, _SdsMonthPageView_pageYear_accessor_storage, "f"); }
        set pageYear(value) { __classPrivateFieldSet(this, _SdsMonthPageView_pageYear_accessor_storage, value, "f"); }
        get locale() { return __classPrivateFieldGet(this, _SdsMonthPageView_locale_accessor_storage, "f"); }
        set locale(value) { __classPrivateFieldSet(this, _SdsMonthPageView_locale_accessor_storage, value, "f"); }
        get currentMonth() { return __classPrivateFieldGet(this, _SdsMonthPageView_currentMonth_accessor_storage, "f"); }
        set currentMonth(value) { __classPrivateFieldSet(this, _SdsMonthPageView_currentMonth_accessor_storage, value, "f"); }
        get stateMapper() { return __classPrivateFieldGet(this, _SdsMonthPageView_stateMapper_accessor_storage, "f"); }
        set stateMapper(value) { __classPrivateFieldSet(this, _SdsMonthPageView_stateMapper_accessor_storage, value, "f"); }
        render() {
            return html `
            <div
                id="content-container"
                class="sds-month-picker"
                @click="${this.itemClickHandler}"
                @keypress="${this.itemKeyPressHandler}"
                @mouseover="${this.handleHover}"
            >
                ${this.renderItems()}
            </div>
        `;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        /**
         * state mapper for month, the result is delegated to sds-datepicker-item
         */
        setMonthStateMapper(stateMapper) {
            this.stateMapper = stateMapper;
            this.updateStates();
            this.requestUpdate('stateMapper');
        }
        updateStates() {
            this._items.forEach(item => item.setAttribute('state', this.stateMapper([this.pageYear, assertMonth(parseInt(item.identifier))])));
        }
        async firstUpdated() {
            await this.updateComplete;
            this.initContentContainer();
        }
        initContentContainer() {
            var _a;
            const contentContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#content-container');
            if (contentContainer) {
                this._contentContainer = contentContainer;
            }
        }
        async updated() {
            await this.updateComplete;
            this.setItems();
        }
        setItems() {
            this._items = Array.from(this._contentContainer.querySelectorAll('sds-datepicker-item').values());
        }
        renderItems() {
            const items = [];
            const currentMonth = this.currentMonth
                ? this.currentMonth
                : monthDateToKey(new Date().getFullYear(), (new Date().getMonth() + 1));
            getMonthNames(this.locale, 'short').forEach((monthName, monthNumber) => items.push(this.getItemTemplate(monthName, monthNumber + 1, currentMonth)));
            return items;
        }
        getItemTemplate(monthName, monthNumber, currentMonth) {
            const monthKey = monthDateToKey(this.pageYear, assertMonth(monthNumber));
            return html ` <sds-datepicker-item
            class="sds-date-picker-item sds-date-picker-month-item"
            tabindex="0"
            identifier="${monthNumber}"
            value="${monthName}"
            ?current="${monthKey === currentMonth}"
            state="${this.stateMapper([this.pageYear, assertMonth(monthNumber)])}"
        ></sds-datepicker-item>`;
        }
    };
    _SdsMonthPageView_pageYear_accessor_storage = new WeakMap();
    _SdsMonthPageView_locale_accessor_storage = new WeakMap();
    _SdsMonthPageView_currentMonth_accessor_storage = new WeakMap();
    _SdsMonthPageView_stateMapper_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsMonthPageView");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _pageYear_decorators = [property({ type: Number })];
        _locale_decorators = [property()];
        _currentMonth_decorators = [property()];
        _stateMapper_decorators = [state()];
        __esDecorate(_classThis, null, _pageYear_decorators, { kind: "accessor", name: "pageYear", static: false, private: false, access: { has: obj => "pageYear" in obj, get: obj => obj.pageYear, set: (obj, value) => { obj.pageYear = value; } }, metadata: _metadata }, _pageYear_initializers, _pageYear_extraInitializers);
        __esDecorate(_classThis, null, _locale_decorators, { kind: "accessor", name: "locale", static: false, private: false, access: { has: obj => "locale" in obj, get: obj => obj.locale, set: (obj, value) => { obj.locale = value; } }, metadata: _metadata }, _locale_initializers, _locale_extraInitializers);
        __esDecorate(_classThis, null, _currentMonth_decorators, { kind: "accessor", name: "currentMonth", static: false, private: false, access: { has: obj => "currentMonth" in obj, get: obj => obj.currentMonth, set: (obj, value) => { obj.currentMonth = value; } }, metadata: _metadata }, _currentMonth_initializers, _currentMonth_extraInitializers);
        __esDecorate(_classThis, null, _stateMapper_decorators, { kind: "accessor", name: "stateMapper", static: false, private: false, access: { has: obj => "stateMapper" in obj, get: obj => obj.stateMapper, set: (obj, value) => { obj.stateMapper = value; } }, metadata: _metadata }, _stateMapper_initializers, _stateMapper_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsMonthPageView = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.SELECT_EVENT = 'sds.month-page-view.select';
    _classThis.HOVER_EVENT = 'sds.month-page-view.hovered';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsMonthPageView = _classThis;
})();
export { SdsMonthPageView };
